import { createFeatureSelector, createSelector } from "@ngrx/store";
import { State } from "./customer.reducers";

export const selectFeature = createFeatureSelector<State>("customer");

export const selectCustomer = createSelector(
  selectFeature,
  (state) => state.customer
);

export const selectIsLoaded = createSelector(
  selectFeature,
  (state) => state.isLoaded
);

export const selectAllCustomers = createSelector(
  selectFeature,
  (state) => (state.customer ? [state.customer] : [])
);

export const selectEntitlements = createSelector(
  selectFeature,
  (state) => state.entitlements
);

export const selectPlatformPurchase = createSelector(
  selectFeature,
  (state) => state.platformPurchase
);
